module.exports = __webpack_public_path__ + "files/b5715801209ca316f027de630f581085.png";